import { Pipe, PipeTransform } from '@angular/core';
import { enumIdentifierQualifier } from '@data-layer/enums/common';

@Pipe({
  name: 'identifierQualifier',
})
export class IdentifierQualPipe implements PipeTransform {
  public transform(value: enumIdentifierQualifier): any {
    return 'IDENTIFIER_QUALIFIER.' + value;
  }
}
